<template>
  <div class="page-wrapper about">
    <div class="about-background"></div>
    <main class="contribute" id="topPage">
      <div class="narrow">
        <h1 class="wcrc">Campfire</h1>
        <p>Community contributions from people with memories of the peace camps.</p>
      </div>
      <section class="wide">
        <GetContent/>
      </section>
      <section class="narrow">
        <h2>Contribute</h2>
        <p>Share your image and message around the Campfire.</p>
        <PostContent/>
      </section>
    </main>
    <SocialMedia/>

  </div>
</template>


<script>
import PostContent from "../components/PostContent";
import GetContent from '../components/GetContent'
import SocialMedia from "@/components/SocialMedia";

export default {
  name: "Plenum",
  components: {
    PostContent,
    GetContent,
    SocialMedia
  },
  mounted() {
    document.getElementById("topPage").scrollIntoView();
  }
}
</script>

<style scoped>
.contribute {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 3em;
  width: calc(100% - 1em);
  padding: 2em .5em 0;
}

@media screen and (min-width: 660px) {
  .contribute {
    padding: 0;
  }

  .narrow {
    width: 32em;
    max-width: 32em;
  }

  .wide {
    width: 100%;
    padding: 0 1em;
  }
}
</style>
